module.exports = __webpack_public_path__ + "static/girl-92ff49b3272a577e78d51c39a99f0b0f.svg";